/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  content: {
    type: [String, Number, Function]
  },
  "default": {
    type: [String, Number, Function]
  },
  disabled: Boolean,
  href: {
    type: String,
    "default": ""
  },
  maxWidth: {
    type: String,
    "default": void 0
  },
  replace: Boolean,
  router: {
    type: Object
  },
  target: {
    type: String,
    "default": "_self",
    validator: function validator(val) {
      return ["_blank", "_self", "_parent", "_top"].includes(val);
    }
  },
  to: {
    type: [String, Object]
  }
};

export { props as default };
//# sourceMappingURL=breadcrumb-item-props.js.map
